module.exports = __webpack_public_path__ + "static/media/qd_monthly-report-3.1e9317a8.png";